module.exports = __webpack_public_path__ + "portal/assets/img/logo.e1c29f82.svg";